// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3bJEu","inner":"Footer_inner__npnna","nextIcon":"Footer_nextIcon__T984v","innerLeft":"Footer_innerLeft__22R59"};